import { exclusives } from "@/mocks/gossip";

export default function Exclusive() {
  return (
    <section id="exclusive" className="relative scroll-mt-24 bg-[#241b13] py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex flex-col gap-4 text-center md:flex-row md:items-end md:justify-between md:text-left">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center md:mx-0 md:items-start md:text-left">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-gold-500/15 px-3 py-1 text-[12px] font-semibold tracking-wide text-gold-300 ring-1 ring-gold-500/30">
              <i className="ri-vip-diamond-fill" />
              独家抢先专区
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-white md:text-[32px]">
              全网独一份的深挖，都是前线阿瓜蹲出来的
            </h2>
            <p className="mt-3 text-[14px] leading-relaxed text-stone-400 md:text-[15px]">
              吃瓜前线独家首发与加急调查：时间线、资金链、人际网，一次讲透。不标题党，只上硬料。
            </p>
          </div>
          <span className="mx-auto inline-flex items-center gap-2 self-start rounded-full border border-white/15 px-3 py-1.5 text-[12px] text-stone-300 md:mx-0 md:self-auto">
            <i className="ri-verified-badge-fill text-gold-400" />
            本周独家 3 篇 · 全部通过双重核实
          </span>
        </div>

        <div className="mt-8 flex flex-col gap-6">
          {exclusives.map((e, idx) => {
            const reversed = idx % 2 === 1;
            return (
              <article
                key={e.id}
                className="group grid grid-cols-1 overflow-hidden rounded-2xl bg-white/5 ring-1 ring-white/10 lg:grid-cols-5"
              >
                <div className={"relative h-64 w-full overflow-hidden lg:h-auto " + (reversed ? "lg:order-2 lg:col-span-2" : "lg:col-span-2")}>
                  <img
                    src={e.image}
                    alt={e.title + " 吃瓜前线独家"}
                    title={e.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-md bg-gold-500 px-2.5 py-1 text-[12px] font-bold text-[#241b13]">
                    {e.tag}
                  </span>
                </div>
                <div className={"flex flex-col justify-center p-5 lg:col-span-3 md:p-7 " + (reversed ? "lg:order-1" : "")}>
                  <div className="flex flex-wrap items-center gap-3 text-[12px] text-stone-400">
                    <span>
                      <i className="ri-time-line mr-1" />
                      {e.time}
                    </span>
                    <span className="inline-flex items-center gap-1 text-gold-400">
                      <i className="ri-book-open-line" />
                      {e.readMin}
                    </span>
                    <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-brand-500/15 px-2.5 py-0.5 text-brand-300 ring-1 ring-brand-500/30">
                      <i className="ri-flashlight-fill" />
                      独家抢先首发
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-[20px] font-bold leading-snug text-white md:text-[24px] group-hover:text-gold-200">
                    {e.title}
                  </h3>
                  <p className="mt-3 text-[14px] leading-relaxed text-stone-400">{e.lead}</p>
                  <a
                    href="#newsletter"
                    className="mt-5 inline-flex items-center gap-1 whitespace-nowrap self-start rounded-lg bg-white px-4 py-2 text-[13px] font-semibold text-[#241b13] transition-colors hover:bg-gold-100"
                  >
                    解锁全文内幕 <i className="ri-arrow-right-up-line" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}